import React, { useState } from 'react';
import { Layout, Menu, Button, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  UnorderedListOutlined,
  AppstoreOutlined,
  ReloadOutlined
} from '@ant-design/icons';
import TaskSearch from './TaskSearch';
import TaskList from './TaskList';
import TaskKanban from './TaskKanban';
import { TaskSearchParams } from './task';
import 'antd/dist/reset.css';

const { Header, Content } = Layout;
const { Title } = Typography;

type ViewMode = 'list' | 'kanban';

const TallyTask: React.FC = () => {
  const { t } = useTranslation();
  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [searchParams, setSearchParams] = useState<TaskSearchParams>({
    currentPage: 1,
    pageSize: 20
  });
  const [searchLoading, setSearchLoading] = useState(false);

  const handleSearch = (params: TaskSearchParams) => {
    setSearchLoading(true);
    setSearchParams(params);
    // 模拟搜索延迟
    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
  };

  const handleRefresh = () => {
    handleSearch(searchParams);
  };

  const menuItems = [
    {
      key: 'list',
      icon: <UnorderedListOutlined />,
      label: t('taskManagement.viewModes.list'),
    },
    {
      key: 'kanban',
      icon: <AppstoreOutlined />,
      label: t('taskManagement.viewModes.kanban'),
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh', background: '#fff' }}>
      <Header style={{ 
        background: '#fff', 
        padding: '0 24px',
        borderBottom: '1px solid #f0f0f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Title level={4} style={{ margin: 0, marginRight: 24 }}>
            {t('taskManagement.title')}
          </Title>
          <Menu
            mode="horizontal"
            selectedKeys={[viewMode]}
            items={menuItems}
            style={{ border: 'none', minWidth: 200 }}
            onSelect={({ key }) => setViewMode(key as ViewMode)}
          />
        </div>
      </Header>

      <Content>
        {/* 搜索区域 */}
        <TaskSearch 
          onSearch={handleSearch} 
          loading={searchLoading}
        />

        {/* 内容区域 */}
        {viewMode === 'list' ? (
          <TaskList 
            searchParams={searchParams}
            onSearchParamsChange={setSearchParams}
          />
        ) : (
          <TaskKanban 
            searchParams={searchParams}
          />
        )}
      </Content>
    </Layout>
  );
};

export default TallyTask;